import React, { useState, useRef } from 'react';

import Baloon from './baloon';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import styles, { mainCls, arrowSizes, defaultBg } from './style';

const useStyles = createStyle(styles);

export default function Tooltip({
  text,
  className,
  position = 'top',
  width = null,
  handleClick = false,
  baloonCls = '',
  baloonBgColor = defaultBg,
  children,
}) {
  const cls = useStyles();
  const toolTip = useRef(null);
  const trigger = useRef(null);
  const [offset, setOffset] = useState({});
  const [revealed, setRevealed] = useState(false);
  const [hidden, setHidden] = useState(false);

  const revealTooltip = () => {
    const currentBgVar = window.getComputedStyle(document.body).getPropertyValue('--toolTipBg');  
    if (!currentBgVar || baloonBgColor !== currentBgVar) {
      document.body.style.setProperty('--toolTipBg', baloonBgColor);
    }
    if (!Object.keys(offset).length && !['top', 'left'].includes(position)) {
      if (position === 'bottom') {
        setOffset({ top: trigger.current.clientHeight + arrowSizes.long });  
      } else if (position === 'right') {
        setOffset({ left: trigger.current.clientWidth + arrowSizes.long });
      }
    }
    setHidden(false);
    setRevealed(true);
  };

  const hideTooltip = () => {
    setRevealed(false);
    setHidden(true);
  };

  // recursively checks if a DOM element is the child of another
  const isChildOf = (child, parent) => {
    if (child.parentNode === parent) {
      return true;
    } if (child.parentNode === null) {
      return false;
    }
    return isChildOf(child.parentNode, parent);
  };

  const clickOutside = (e) => {
    if (!isChildOf(e.target, toolTip.current)) {
      hideTooltip();
    }
  };

  const toggleTooltip = (e) => {
    if (handleClick) {
      if (revealed) {
        document.removeEventListener('click', clickOutside);
        const isTrigger = e.target === trigger.current;
        (!isChildOf(e.target, toolTip.current) || isTrigger) && hideTooltip();
      } else {
        document.addEventListener('click', clickOutside);
        revealTooltip();
      }
    }
  };

  const classNameBaloon = makeClassName([
    cls[`${mainCls}__baloon`],
    cls[`${mainCls}__baloon--${position}`],
    baloonCls,
  ]);

  const mEnter = () => {
    if (handleClick) {
      return;
    }
    revealTooltip();
  };

  const mLeave = () => {
    if (handleClick) {
      return;
    }
    hideTooltip();
  }

  return (
    <div 
      ref={toolTip}
      className={className}
      style={{ zIndex: 1 }}
    >
      <div
        ref={trigger}
        className={cls[`${mainCls}__trigger`]}
        onClick={toggleTooltip}
        onMouseEnter={mEnter}
        onMouseLeave={mLeave}
      >
        {children}
      </div>
      <Baloon
        text={text}
        className={classNameBaloon}
        position={position}
        offset={offset}
        width={width}
        revealed={revealed}
        hidden={hidden}
      />
    </div>
  );
}